import { benefits } from '@/mocks/content';

export default function BenefitsSection() {
  return (
    <section className="relative py-16 md:py-24 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="mb-12 md:mb-16">
          <p className="text-xs md:text-sm font-medium text-foreground-500 uppercase tracking-widest mb-3">
            Why Choose Us
          </p>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-tight">
            What Makes This <span className="italic text-primary-500">Kakobuy Spreadsheet</span> Different
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-2xl">
            Our Kakobuy Spreadsheet resource center stands apart with daily updates, community verification, and intuitive organization that makes product discovery effortless.
          </p>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {benefits.map((benefit, i) => (
            <div
              key={i}
              className="group p-6 md:p-8 rounded-2xl bg-background-100 border border-background-200/60 card-hover"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 mb-5 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                <i className={`${benefit.icon} text-xl md:text-2xl`}></i>
              </div>
              <h3 className="text-lg md:text-xl font-heading font-bold text-foreground-900 mb-2.5">
                {benefit.title}
              </h3>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                {benefit.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}